<div
  app-modal-content
  class="flex flex-col rounded-none! lg:rounded-2xl! md:max-h-[90vh] w-screen overflow-hidden md:overflow-y-auto px-6! pt-0! pb-6! lg:max-h-[60rem] lg:w-[80rem]"
>
  <div class="flex p-6 rounded-none! items-center relative lg:rounded-2xl">
    <h1 class="w-full text-center text-3xl font-semibold text-modules-eclass-500">{{ title | translate }}</h1>
    <button type="button" app-icon-button dialogClose class="p-0!">
      <svg-icon
        class="absolute h-10 w-10 select-none text-modules-eclass-500"
        src="assets/icons/icon-close-fine.svg"
      ></svg-icon>
    </button>
  </div>
  <div
    class="px-4 py-6 rounded-3xl overflow-y-auto h-[calc(var(--vh)-10rem)] md:h-full shadow-[inset_0_2px_8px_rgba(0,0,0,0.15)]"
  >
    <div class="flex w-full flex-col gap-2 px-8 pb-8 pt-4">
      <div class="flex w-full justify-between items-center flex-wrap gap-4 md:flex-row">
        <div class="flex flex-col gap-1">
          <h3 class="text-lg">{{ data.element.title }}</h3>
          <span class="truncate leading-5 text-subtitle">
            {{ 'geral.data' | translate }}: {{ data.item.date | date: 'dd/MM/yyyy HH:mm' }}
          </span>
          <ng-container
            [ngComponentOutlet]="data.subtitle"
            [ngComponentOutletInputs]="{ item: data.item }"
          ></ng-container>
        </div>
        <div class="flex gap-2 justify-end items-center">
          @if (isActivity) {
            @if (data.element.evaluative) {
              @if (data.element?.answers?.score) {
                <div
                  class="flex h-fit w-48 flex-initial flex-col gap-2 self-end rounded-xl border-l-4 border-theme-500 px-3 py-2 shadow-md shadow-black/20"
                >
                  <span class="text-base font-medium text-base-gray-950" translate> eclass.tarefa.nota-alcancada </span>
                  <div class="font-medium leading-none">
                    <span class="text-xl text-theme-500">
                      {{ showScore(data.element) }}
                    </span>
                    <span class="text-base-gray-950" translate> eclass.aula.pontos-abrev </span>
                  </div>
                </div>
              } @else {
                @if (data.element.score) {
                  <div
                    class="flex h-fit w-48 flex-initial flex-col gap-2 self-end rounded-xl border-l-4 border-theme-500 px-3 py-2 shadow-md shadow-black/20"
                  >
                    <span class="text-base font-medium text-base-gray-950" translate>
                      eclass.aula.valor-atividade
                    </span>
                    <div class="font-medium leading-none">
                      <span class="text-xl text-theme-500"> {{ data.element?.score }} </span>
                      <span class="text-base-gray-950" translate> eclass.aula.pontos-abrev </span>
                    </div>
                  </div>
                }
              }
            }

            <div
              class="flex h-fit w-60 flex-initial flex-col gap-2 self-end rounded-xl border-l-4 border-theme-500 px-3 py-2 shadow-md shadow-black/20"
            >
              <span class="text-base font-medium text-base-gray-950" translate> eclass.tarefa.prazo-entrega </span>
              <div class="font-medium leading-none">
                <span class="text-xl font-medium leading-none text-theme-500">
                  {{ data.element.date_end | dateTranslate: 'd' }}
                </span>
                <span class="text-base font-medium leading-none text-base-gray-950">
                  {{ 'geral.de' | translate }} {{ data.element.date_end | dateTranslate: 'MMMM' }}
                  {{ 'geral.as' | translate }}
                </span>
                <span class="text-xl font-medium leading-none text-theme-500">
                  {{ data.element.date_end | date: 'HH:mm' }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>

      @if (data.element.description) {
        <div
          class="ck-content relative h-full w-full mt-2 [&>p>iframe]:relative! [&>p>iframe]:min-h-[400px]! [&>p>iframe]:min-w-[300px]! [&>p>iframe]:max-w-full! *:text-xl"
          [innerHtml]="data.element.description | safe: 'html'"
        ></div>
      } @else if (data.element.content) {
        <div
          class="ck-content relative h-full w-full mt-2 [&>p>iframe]:relative! [&>p>iframe]:min-h-[400px]! [&>p>iframe]:min-w-[300px]! [&>p>iframe]:max-w-full!"
          [innerHtml]="data.element.content | safe: 'html'"
        ></div>
      }

      @if ((data.element.attachments | noEmpty) || (canShowUpload && !data.readonly)) {
        <div class="mt-8 flex flex-col gap-5 xl:flex-row">
          @if (data.element.attachments | noEmpty) {
            <app-resource-component
              class="w-full"
              bgColor="bg-indigo-400"
              [title]="'eclass.aula.recurso-aula' | translate"
              [attachments]="data.element.attachments"
            ></app-resource-component>
          }
        </div>
      }

      @if (!!data.element.trail_elements?.length) {
        <div class="grid h-auto gap-4 pt-2">
          <app-accordion>
            <app-accordion-item>
              <div app-accordion-header class="py-1!">
                <div class="flex items-center justify-between gap-4">
                  <div class="flex items-center gap-4">
                    <svg-icon
                      class="flex w-6 text-modules-learning-trails-500"
                      src="assets/icons/icon-degree.svg"
                    ></svg-icon>

                    <span class="text-md text-modules-learning-trails-500" translate>eclass.trilhas-aula</span>
                  </div>
                  @if (!!data.element.trail_elements?.length) {
                    <div class="px-10">
                      <button
                        (click)="onOpenModal(data.element.id, data.element.trail_elements)"
                        type="submit"
                        app-icon-button
                      >
                        <svg-icon
                          app-tooltip
                          [tooltip]="'eclass.visualizar-todas' | translate"
                          class="flex w-6 h-6 justify-center text-[#009357]"
                          src="assets/icons/icon-view.svg"
                        >
                        </svg-icon>
                      </button>
                    </div>
                  }
                </div>
              </div>
              <ng-template app-accordion-lazy>
                <div app-accordion-content class="rounded-xl! bg-[#fafafa] p-3! shadow shadow-black/20">
                  <div class="flex w-full flex-col items-end gap-2 pl-1">
                    @for (trailElement of data.element.trail_elements; track trailElement) {
                      <div class="relative z-20 w-full">
                        <div
                          (click)="onOpenModalElement(data.element.id, trailElement)"
                          class="flex h-[3.25rem] w-full cursor-pointer items-center justify-between rounded-md bg-white shadow shadow-black/20"
                        >
                          <div class="flex w-full items-center justify-start gap-4 px-4">
                            <div>
                              <svg-icon
                                class="flex w-6 h-6"
                                [ngClass]="getStyleTextIcon(trailElement?.tipo)"
                                [src]="'assets/icons/' + mapTypeToIcon(trailElement?.tipo)"
                              >
                              </svg-icon>
                            </div>
                            <div class="flex w-full flex-col items-start justify-start">
                              <p class="text-theme-950">{{ trailElement?.titulo }}</p>
                            </div>
                          </div>
                          <div class="mr-2 flex justify-center p-1">
                            <svg-icon
                              app-tooltip
                              [tooltip]="'eclass.visualizar' | translate"
                              class="flex w-6 h-6 justify-center text-[#009357]"
                              src="assets/icons/icon-view.svg"
                            >
                            </svg-icon>
                          </div>
                        </div>
                        <div class="absolute -left-1 top-0 -z-10 h-[3.25rem] w-3 rounded-l-md bg-[#009357]"></div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </app-accordion-item>
          </app-accordion>
        </div>
      }

      @if (!!data.element.games?.length) {
        <div class="grid h-auto gap-4 pt-2">
          <app-accordion>
            <app-accordion-item>
              <div app-accordion-header class="py-1!">
                <div class="flex items-center justify-between gap-4">
                  <div class="flex items-center gap-4">
                    <svg-icon class="flex w-6 h-6 text-modules-games-500" src="assets/icons/icon-dice.svg"></svg-icon>

                    <span class="text-md text-modules-games-500" translate>eclass.jogos-aula</span>
                  </div>
                </div>
              </div>
              <ng-template app-accordion-lazy>
                <div app-accordion-content class="rounded-xl! bg-[#fafafa] p-3! shadow shadow-black/20">
                  <div class="flex w-full flex-col items-end gap-2 pl-1">
                    @for (game of data.element.games; track game) {
                      <div class="relative z-20 w-full">
                        <div
                          (click)="onOpenModalGame(game)"
                          class="flex h-[4rem] w-full cursor-pointer items-center justify-between rounded-md bg-white shadow shadow-black/20"
                        >
                          <div class="flex w-full items-center justify-start gap-4 p-4">
                            <div class="flex justify-start">
                              <a
                                app-icon-button
                                class="w-fit overflow-hidden rounded-full! bg-white! p-3 shadow-inner shadow-black/40 brightness-100!"
                              >
                                <svg-icon
                                  class="flex h-6 w-6 transition duration-300"
                                  src="assets/icons/icon-botoes-controle.svg"
                                ></svg-icon>
                              </a>
                            </div>
                            <div class="flex w-full flex-col items-start justify-start">
                              <strong class="truncate">{{ game.topic }}</strong>
                              <span>{{ game.name }}</span>
                            </div>
                          </div>
                          <div class="mr-2 flex justify-center p-1">
                            <svg-icon
                              app-tooltip
                              [tooltip]="'eclass.visualizar' | translate"
                              class="flex w-6 h-6 cursor-pointer justify-center text-modules-games-700 duration-300 hover:scale-125"
                              src="assets/icons/icon-view.svg"
                            >
                            </svg-icon>
                          </div>
                        </div>
                        <div class="absolute -left-1 top-0 -z-10 h-[4rem] w-3 rounded-l-md bg-modules-games-600"></div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </app-accordion-item>
          </app-accordion>
        </div>
      }

      <div>
        @if (canShowUpload && !data.readonly) {
          <app-summary-upload
            class="w-full"
            (refresh)="onRefresh()"
            [data]="{
              activity: data.element,
              class: data.element.daily,
            }"
          ></app-summary-upload>
        }
      </div>
    </div>
  </div>
  @if (logo()) {
    <div class="flex w-full px-6 pt-6 justify-center text-gray-300">
      <svg-icon class="w-10 block" [src]="logo()"></svg-icon>
    </div>
  }
</div>
